<template>
  <AdminHeader
      :admin-i-d="adminID"
      :admin-brand-name="brandName"/>
  <SpaceOverview class="space-detail"
                 :space-id="spaceId"
                 :space-info-data="spaceInfoObj"></SpaceOverview>
  <Footer class="bg-osn-grey-03"></Footer>

</template>
<script setup>

import {ref} from "vue";
import {useSettingStore} from "@/stores/setting";

import SpaceOverview from "~/components/SpaceDetail/SpaceOverview.vue";
import AdminHeader from "~/components/AdminHomePage/AdminHeader.vue";
import Footer from "@/components/Footer/Footer.vue";
import {getSpaceInfo} from "@/api/space";
import {useGoTo} from "@/composables/useGoTo";


const route = useRoute();
const {goHome} = useGoTo();
const settingStore = useSettingStore()
const spaceId = ref(Number(route.params.spaceid) || 0)
const spaceInfoObj = useState('spaceInfoObj', () => null)
const adminID = ref(-1)
const brandName = ref('')

const getCategoryNamesString = (categories) => {
  categories = categories || []
  return categories.map(category => category.name).join(' ')
}
const setSeoMeta = (seoMeta) => {
  useSeoMeta(seoMeta)
}
const handleSpaceInfo = async () => {
  const picUrl = import.meta.env.VITE_APP_BASE_IMG_URL
  const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID
  const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID
  try {
    const {data: SpaceInfoData} = await useAsyncData('getAdminSpaceInfo', () => getSpaceInfo(spaceId.value, goHome));
    if (SpaceInfoData.value) {
      spaceInfoObj.value = SpaceInfoData.value
      adminID.value = SpaceInfoData.value.admin_id
      brandName.value = SpaceInfoData.value.brand_name

      setSeoMeta({
        title: `${SpaceInfoData.value.brand_name} ${SpaceInfoData.value.name}｜立即預約！空間便利店`,
        description: SpaceInfoData.value.introduction,
        keywords: `${getCategoryNamesString(SpaceInfoData.value.categories[Number(typeCategoryId)])} ${getCategoryNamesString(SpaceInfoData.value.categories[Number(usageCategoryId)])}`,
        ogTitle: `${SpaceInfoData.value.name}｜立即預約！空間便利店`,
        ogDescription: SpaceInfoData.value.introduction,
        ogImage: `${picUrl}${SpaceInfoData.value.photos[0].url}`,
        ogImageAlt: `${SpaceInfoData.value.name}｜立即預約！空間便利店`
      })
      /// space_usage_status 日期排序
      spaceInfoObj.value.space_usage_status.sort((a, b) => new Date(a.date) - new Date(b.date))
      spaceInfoObj.value.accessories.forEach(accessory => {
        accessory.ellipsis = true
        accessory.selected = false
      })
    }
  } catch (error) {
    goHome()
    console.log(error)
  }

}


// SSR 取得空間資料
if (spaceId.value !== 0) {
  handleSpaceInfo()
}


const setHomeRouter = (aid) => {
  settingStore.updateHomeRouter(`/admin/${aid}`)
}
</script>
<style scoped
       lang="scss">
div.admin-space-wrap {
  @apply md:mx-auto md:w-[520px] relative;
}

.space-detail {
  @apply mx-auto
  pc:pt-[20px] pc:max-w-[90%] pc:px-[8%];
}

</style>
